var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"close"},[React.createElement("rect",{"width":"24","height":"24","transform":"rotate(180 12 12)","opacity":"0","key":0}),React.createElement("path",{"d":"M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z","key":1})])));
}

CloseInline.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
